import React, { useEffect, useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, CircularProgress, Card, Typography, IconButton, Chip, Menu, Dialog, DialogTitle, DialogContent, Grid, DialogActions, Tooltip } from "@mui/material";
import axios from "axios";
import CustomLabel from "./CustomLabel";
import { useTheme } from "@emotion/react";
import Cookies from "js-cookie";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup"
import { ReactComponent as CloseIcon } from "assets/close_icon.svg"
import PerfectScrollbar from "react-perfect-scrollbar"
import { containerRef } from "utils/index";
import { ChangePipelineInvestorStatus, FetchPipelineStatus } from "api/startup_applications";
import { useToast } from "context/ToastContext";
import { KeyboardArrowDown } from "@mui/icons-material";
import DeleteConfirmationDialog from "ui-components/popups/DeleteConfirmationPopup";
import { Primary } from 'ui-components/Buttons';

// const statusOptions = ["New", "Shortlisted", "Selected", "Rejected"];

// const CardHeader = ({ title, Actions }) => {
//     return <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
//         <Typography fontWeight={700} fontSize={"1.25rem"}>
//             {title}
//         </Typography>
//         {Actions && <Actions />}
//     </Box>
// }

// const StatusChange = ({ isLoading, selectedStartupId, handleSubmit, handleClose, statuses = [], statusValue = null }) => {

//     const [validationObj, setValidationObj] = React.useState({
//         status: Yup.string().required("Status is required"),
//     });
//     const statusValidationSchema = Yup.object({ ...validationObj });
//     const formik = useFormik({
//         initialValues: {
//             status: statusValue ? statusValue : null,
//         },
//         validationSchema: statusValidationSchema,
//         enableReinitialize: true,
//         validateOnChange: true,
//         onSubmit: (values) => {
//             const payload = {
//                 "investor_status_id": values?.status
//             }
//             handleSubmit({ payload: payload })
//         },
//     });

//     const theme = useTheme();

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         formik.setValues({ ...formik.values, [name]: value });
//     };

//     const placeholders = {
//         // call_for_money: false,
//         status: "Select status",

//     };

//     return (
//         <FormikProvider value={formik}>
//             <Form onSubmit={formik.handleSubmit} style={{ gap: '1rem' }}>
//                 <IconButton
//                     sx={{ position: "absolute", top: 10, right: 15, padding: 0 }}
//                 >
//                     <CloseIcon width={40} height={40} onClick={handleClose} />
//                 </IconButton>
//                 <DialogTitle sx={{ marginInline: "auto", marginBottom: 1 }}>
//                     <Typography
//                         sx={{
//                             fontSize: "1.5rem",
//                             fontWeight: 700,
//                             lineHeight: "1.75rem",
//                             color: theme.palette.customColors.g300,
//                             paddingLeft: "0.5rem",
//                             textAlign: 'center'
//                         }}
//                     >
//                         Change Status
//                     </Typography>
//                 </DialogTitle>
//                 <DialogContent sx={{ paddingInline: 0, paddingBottom: 1 }}>
//                     <PerfectScrollbar
//                         containerRef={containerRef}
//                         style={{
//                             maxHeight: "calc(-15.625rem + 100dvh)",
//                             paddingInline: "1.5rem",
//                         }}
//                     >
//                         <Grid item container xs={12} columnSpacing={2}>
//                             <Grid item xs={12}>
//                                 <CustomLabel>Status</CustomLabel>
//                                 <Select
//                                     name="status"
//                                     value={formik.values?.status}
//                                     onChange={handleChange}
//                                     placeholder={placeholders?.status}
//                                     sx={{ marginBottom: "0.5rem" }}
//                                     fullWidth
//                                 >
//                                     {statuses?.map((option) => (
//                                         <MenuItem value={option?.value}>{option?.label}</MenuItem>
//                                     ))}
//                                 </Select>
//                             </Grid>
//                         </Grid>
//                     </PerfectScrollbar>
//                 </DialogContent>
//                 <DialogActions
//                     sx={{ paddingInline: "1.5rem", paddingBottom: "1.5rem" }}
//                 >
//                     {/* <Button onClick={handleClose}>Cancel</Button> */}
//                     <Primary
//                         type="submit"
//                         fullWidth
//                         disabled={isLoading}
//                         sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
//                     >
//                         {isLoading ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.2rem'} /> : "Update"}
//                     </Primary>
//                     {/* <Primary sx={{ background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", width: '100%' }} onClick={handleSave}>Save</Primary> */}
//                 </DialogActions>
//                 {/* </Dialog> */}
//             </Form>
//         </FormikProvider>
//     )

// }


export default function StartupStatusSelector({ startupId, statuses, selectedStartupData = null, refetchListing, handleSubmit, customSx, sx = {}, disabled = false }) {
    const theme = useTheme()
    const { addToast } = useToast();
    let [investor_id, setInvestorID] = React.useState(Cookies.get("X-INV-ID") || null);
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [updating, setUpdating] = useState(false);

    const {
        mutateAsync: updateStartupStatusAsync,
        status: updateStartupStatusStatus,
        error: updateStartupStatusError,
        isLoading: isUpdatingStartupStatus,
        data: updateStartupStatusResponse,
    } = ChangePipelineInvestorStatus();

    const [openChangeStatus, setOpenChangeStatus] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(false);

    const handleOpenMenu = (event) => {
        setOpenChangeStatus(true);
        setAnchorEl(event)
    }

    const handleCloseMenu = () => {
        setOpenChangeStatus(false);
        setAnchorEl(null)
    }

    const [openConfirmationPopup, setOpenConfirmationPopup] = React.useState(false);

    const handleCloseConfirmationPopup = () => {
        setStatus(null);
        setOpenConfirmationPopup(false);
    }
    const handleSubmitConfirmation = () => {
        // console.log({
        //     "investor_status_id": status,
        //     "pipeline_id": selectedStartupData?.pipeline_id
        // })
        handleSubmit({
            // payload: {
            //     "investor_status_id": status,
            //     "pipeline_id": selectedStartupData?.pipeline_id,
            //     ...selectedStartupData
            // }

            payload: {
                startup_id: selectedStartupData?.startup_id,
                investor_id: selectedStartupData?.investor_id,             // pehle spread karo
                investor_status_id: status,          // phir overwrite karo
                pipeline_id: selectedStartupData?.pipeline_id, // aur yeh confirm karo
            }

        });
        handleCloseConfirmationPopup()
    }

    // const {
    //     data,
    //     isLoading: isLoadingStatus,
    //     refetch: refetchStatus,
    //     status: pipeline_status
    // } = FetchPipelineStatus({
    //     id: startupId, investor_id,
    // })

    // React.useEffect(() => {
    //     if (!selectedStartupData)
    //         // refetchStatus()
    // }, [investor_id, startupId])

    //   useEffect(() => {
    //     const fetchStatus = async () => {
    //       try {
    //         const res = await axios.get(`/api/startups/${startupId}`);
    //         setStatus(res.data.status || "New");
    //       } catch (err) {
    //         console.error("Error fetching status", err);
    //       } finally {
    //         setLoading(false);
    //       }
    //     };

    //     fetchStatus();
    //   }, [startupId]);

    //   const handleChange = async (event) => {
    //     const newStatus = event.target.value;
    //     setUpdating(true);
    //     try {
    //       await axios.patch(`/api/startups/${startupId}/status`, { status: newStatus });
    //       setStatus(newStatus);
    //     } catch (err) {
    //       console.error("Error updating status", err);
    //     } finally {
    //       setUpdating(false);
    //     }
    //   };

    //   if (loading) return <CircularProgress size={24} />;


    const statusValue = selectedStartupData ? selectedStartupData?.status : null;

    // const handleSubmit = ({ payload }) => {
    //     // console.log(payload, "payload")
    //     // updateStartupStatusAsync({
    //     //     payload: {
    //     //         "status": payload?.status,
    //     //     }
    //     //     , pipeline_id: selectedStartupData ? selectedStartupData?.pipeline_id : data?.pipeline_id
    //     // }, {
    //     //     onSuccess: async () => {
    //     //         addToast(`Moved to ${statuses?.find(item => item?.value === payload?.status)?.label}`, "success")
    //     //         await refetchListing();
    //     //         await refetchStatus();
    //     //         handleCloseMenu();
    //     //     }
    //     // }).then((response) => {

    //     // }).catch((error) => {

    //     // })
    // }
    // console.log(selectedStartupData, "selectedStartupData")
    return (
        <Box mb={0}
            sx={sx}
        // sx={{ minWidth: 200 }}
        >
            {
                selectedStartupData
                &&
                <Tooltip title={statuses?.find(item => item?.value === statusValue)?.label || null}>
                    <Chip
                        disabled={disabled}
                        label={<span style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', gap: 6, width: 120 }}>
                            <span style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                color: theme.palette.customColors.g200,
                            }}>
                                {customSx && "Status:"} {statuses?.find(item => item?.value === statusValue)?.label || "Select Status"}
                            </span>
                            {isUpdatingStartupStatus ?
                                <CircularProgress size={"0.8rem"} sx={{
                                    color: "black"
                                }} /> :
                                <KeyboardArrowDown sx={{
                                    color: theme.palette.customColors.g200,
                                    fontSize: '1.2rem'
                                }} />}
                        </span>} style={{ borderRadius: '4px', marginBottom: '-1rem' }} clickable onClick={(e) => {
                            handleOpenMenu(e);
                            // console.log(e.currentTarget)
                        }} sx={{
                            // background: theme.palette.customColors.white,
                            // border: `1px solid ${theme.palette.customColors.b50}`,
                            // ":hover": {
                            //     background: theme.palette.customColors.b50,
                            //     "& > .MuiTouchRipple-root": {
                            //         background: "transparent",
                            //     }
                            // },
                            // marginLeft: {xs: "1rem", sm: undefined},
                            // marginLeft: {xs: "1rem"},
                            // "& > .MuiChip-label": {
                            //     paddingRight: '0.375rem'
                            // },

                        }} variant="outlined" />
                </Tooltip>
            }
            {(selectedStartupData) && <Select
                name="status"
                value={statusValue}
                onChange={(event) => {
                    const newStatus = event.target.value;
                    if (statuses && Array.isArray(statuses)) {
                        if (statuses?.find(item => item?.value === newStatus)?.mappedValue === "rejected") {
                            setStatus(newStatus);
                            setOpenConfirmationPopup(true);
                        }
                        else {
                            // console.log(statuses?.find(item => item?.value === newStatus)?.mappedValue === "rejected", "newStatus")
                            handleSubmit({
                                payload: {
                                    "investor_status_id": newStatus,
                                    "pipeline_id": selectedStartupData?.pipeline_id,
                                    "startup_id": selectedStartupData?.startup_id,
                                    "investor_id": selectedStartupData?.investor_id,
                                }
                            })
                        }
                    }
                }}
                open={openChangeStatus}
                onClose={handleCloseMenu}
                onOpen={handleOpenMenu}
                // placeholder={placeholders?.status}
                sx={{
                    marginBottom: "0rem",
                    visibility: 'hidden',
                    height: "0rem",
                    width: "100%",
                    "& > #mui-component-select-status": { padding: "0.5rem", bgcolor: "#ffffff", border: "1px solid #a1a3a7", borderRadius: '8px' }, "& > fieldset.MuiOutlinedInput-notchedOutline": { border: "none" }
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            // Style the dropdown container (ul wrapper)
                            maxHeight: 300,
                            // bgcolor: "lightgray",
                            marginTop: "0.5rem",
                            minWidth: "6.25rem !important",
                            width: "9.375rem",
                            top: "1px",
                            ...customSx,   // 👈 allow override from props
                            "& ul": {
                                // "&.MuiList-root": {
                                // }
                                // padding: 0,
                                // margin: 0,
                                // backgroundColor: "white",
                            },
                            "& li": {
                                fontSize: "1rem",
                                // color: "black",
                            },
                        },
                    },
                }}
                fullWidth
            >

                {/* {console.log("statuses",statuses)} */}
                {statuses?.filter(item => item?.value !== statusValue)?.map((option, index) => (
                    <MenuItem sx={{
                    }} value={option?.value}>{option?.label}</MenuItem>
                ))}
            </Select>}

            <DeleteConfirmationDialog open={openConfirmationPopup} handleClose={handleCloseConfirmationPopup} handleSubmission={handleSubmitConfirmation} heading={"Move to Rejected"} subheading={'Are you sure you want to move this startup to the "Rejected" status?'} ActionText={"Confirm"}
                sx={{
                    "& > .MuiDialog-container > .MuiPaper-root": {
                        maxWidth: 450,
                        borderRadius:
                            "20px"
                    }
                }}
            />
            {/* {console.log(statuses)} */}


            {/* <Dialog maxWidth="xs" open={Boolean(openChangeStatus)} onClose={handleCloseMenu} aria-labelledby="update-Status-dialog" sx={{ "& > .MuiDialog-container > .MuiPaper-root": { width: "100%", borderRadius: "8px" } }}>
                <StatusChange handleClose={handleCloseMenu} handleSubmit={handleSubmit} isLoading={isUpdatingStartupStatus} selectedStartupId={startupId} statusValue={statusValue} statuses={statuses} />
            </Dialog> */}

        </Box>
    );
}
